
import { Component, Vue } from '~/utility/pu-class-decorator'

@Component
export default class FaqStandalonePage extends Vue {
  get slug() {
    return this.$route.params.slug
  }

  get url() {
    return `https://${this.$config.public.envUrl}${this.$route.path}`
  }
}
